module.exports = __webpack_public_path__ + "img/retail07.79ca03c9.png";